// Generated by scripts/write-run-horses-replay-fixtures.ts.
// Do not edit manually.

import type { RunHorsesReplayEventType } from "./event-adapter";

export interface RunHorsesReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface RunHorsesReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: RunHorsesReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface RunHorsesReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "run-horses";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly RunHorsesReplayFixturePlayer[];
  readonly events: readonly RunHorsesReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const RUN_HORSES_REPLAY_FIXTURES: Record<
  string,
  RunHorsesReplayFixture
> = {
  "heuristic-2p": {
    schemaVersion: 1,
    gameType: "run-horses",
    scenario: "heuristic-2p",
    source: "generated",
    capturedAt: "2026-06-18T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "흑 (휴리스틱)",
        role: "host",
      },
      {
        id: "p2",
        name: "백 (휴리스틱)",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "heuristic-2p",
            hostPlayerId: "p1",
            players: [
              {
                playerId: "p1",
                label: "Black",
                color: "black",
              },
              {
                playerId: "p2",
                label: "White",
                color: "white",
              },
            ],
            phase: "playing",
            board: [
              [
                "p1",
                "p1",
                "p1",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "p2",
                "p2",
                "p2",
              ],
              [
                "p1",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "p2",
              ],
              [
                "p1",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "p2",
              ],
              [
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
              ],
              [
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
              ],
              [
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
              ],
              [
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
              ],
              [
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
              ],
              [
                "p2",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "p1",
              ],
              [
                "p2",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "p1",
              ],
              [
                "p2",
                "p2",
                "p2",
                "empty",
                "empty",
                "empty",
                "empty",
                "empty",
                "p1",
                "p1",
                "p1",
              ],
            ],
            currentPlayerId: "p1",
            moveNumber: 0,
            winnerId: null,
            lastAction: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 0,
            col: 1,
          },
          to: {
            row: 2,
            col: 2,
          },
          kind: "knight",
          stateVersion: 0,
        },
      },
      {
        sequenceNumber: 3,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 0,
            col: 8,
          },
          to: {
            row: 2,
            col: 7,
          },
          kind: "knight",
          stateVersion: 1,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 2,
            col: 2,
          },
          to: {
            row: 3,
            col: 4,
          },
          kind: "knight",
          stateVersion: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 2,
            col: 7,
          },
          to: {
            row: 4,
            col: 8,
          },
          kind: "knight",
          stateVersion: 3,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 1,
            col: 0,
          },
          to: {
            row: 2,
            col: 2,
          },
          kind: "knight",
          stateVersion: 4,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 4,
            col: 8,
          },
          to: {
            row: 6,
            col: 7,
          },
          kind: "knight",
          stateVersion: 5,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 9,
            col: 10,
          },
          to: {
            row: 7,
            col: 9,
          },
          kind: "knight",
          stateVersion: 6,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 9,
            col: 0,
          },
          to: {
            row: 7,
            col: 1,
          },
          kind: "knight",
          stateVersion: 7,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 10,
            col: 9,
          },
          to: {
            row: 8,
            col: 8,
          },
          kind: "knight",
          stateVersion: 8,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 10,
            col: 1,
          },
          to: {
            row: 8,
            col: 2,
          },
          kind: "knight",
          stateVersion: 9,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 0,
            col: 2,
          },
          to: {
            row: 2,
            col: 3,
          },
          kind: "knight",
          stateVersion: 10,
        },
      },
      {
        sequenceNumber: 13,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 0,
            col: 9,
          },
          to: {
            row: 1,
            col: 7,
          },
          kind: "knight",
          stateVersion: 11,
        },
      },
      {
        sequenceNumber: 14,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 2,
            col: 2,
          },
          to: {
            row: 7,
            col: 2,
          },
          kind: "slide",
          stateVersion: 12,
        },
      },
      {
        sequenceNumber: 15,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 1,
            col: 7,
          },
          to: {
            row: 5,
            col: 7,
          },
          kind: "slide",
          stateVersion: 13,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 0,
            col: 0,
          },
          to: {
            row: 1,
            col: 2,
          },
          kind: "knight",
          stateVersion: 14,
        },
      },
      {
        sequenceNumber: 17,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 1,
            col: 10,
          },
          to: {
            row: 2,
            col: 8,
          },
          kind: "knight",
          stateVersion: 15,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 2,
            col: 0,
          },
          to: {
            row: 3,
            col: 2,
          },
          kind: "knight",
          stateVersion: 16,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 6,
            col: 7,
          },
          to: {
            row: 4,
            col: 8,
          },
          kind: "knight",
          stateVersion: 17,
        },
      },
      {
        sequenceNumber: 20,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 7,
            col: 2,
          },
          to: {
            row: 8,
            col: 4,
          },
          kind: "knight",
          stateVersion: 18,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 0,
            col: 10,
          },
          to: {
            row: 1,
            col: 8,
          },
          kind: "knight",
          stateVersion: 19,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 8,
            col: 4,
          },
          to: {
            row: 4,
            col: 4,
          },
          kind: "slide",
          stateVersion: 20,
        },
      },
      {
        sequenceNumber: 23,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 4,
            col: 8,
          },
          to: {
            row: 4,
            col: 5,
          },
          kind: "slide",
          stateVersion: 21,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 3,
            col: 4,
          },
          to: {
            row: 2,
            col: 6,
          },
          kind: "knight",
          stateVersion: 22,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 1,
            col: 8,
          },
          to: {
            row: 1,
            col: 3,
          },
          kind: "slide",
          stateVersion: 23,
        },
      },
      {
        sequenceNumber: 26,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 2,
            col: 3,
          },
          to: {
            row: 1,
            col: 5,
          },
          kind: "knight",
          stateVersion: 24,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 1,
            col: 3,
          },
          to: {
            row: 2,
            col: 5,
          },
          kind: "knight",
          stateVersion: 25,
        },
      },
      {
        sequenceNumber: 28,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 3,
            col: 2,
          },
          to: {
            row: 2,
            col: 4,
          },
          kind: "knight",
          stateVersion: 26,
        },
      },
      {
        sequenceNumber: 29,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 7,
            col: 1,
          },
          to: {
            row: 5,
            col: 2,
          },
          kind: "knight",
          stateVersion: 27,
        },
      },
      {
        sequenceNumber: 30,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 1,
            col: 2,
          },
          to: {
            row: 4,
            col: 2,
          },
          kind: "slide",
          stateVersion: 28,
        },
      },
      {
        sequenceNumber: 31,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 8,
            col: 0,
          },
          to: {
            row: 7,
            col: 2,
          },
          kind: "knight",
          stateVersion: 29,
        },
      },
      {
        sequenceNumber: 32,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 7,
            col: 9,
          },
          to: {
            row: 5,
            col: 8,
          },
          kind: "knight",
          stateVersion: 30,
        },
      },
      {
        sequenceNumber: 33,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 7,
            col: 2,
          },
          to: {
            row: 8,
            col: 4,
          },
          kind: "knight",
          stateVersion: 31,
        },
      },
      {
        sequenceNumber: 34,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 8,
            col: 10,
          },
          to: {
            row: 7,
            col: 8,
          },
          kind: "knight",
          stateVersion: 32,
        },
      },
      {
        sequenceNumber: 35,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 2,
            col: 10,
          },
          to: {
            row: 2,
            col: 9,
          },
          kind: "slide",
          stateVersion: 33,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 7,
            col: 8,
          },
          to: {
            row: 8,
            col: 6,
          },
          kind: "knight",
          stateVersion: 34,
        },
      },
      {
        sequenceNumber: 37,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 2,
            col: 9,
          },
          to: {
            row: 4,
            col: 8,
          },
          kind: "knight",
          stateVersion: 35,
        },
      },
      {
        sequenceNumber: 38,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 10,
            col: 10,
          },
          to: {
            row: 8,
            col: 9,
          },
          kind: "knight",
          stateVersion: 36,
        },
      },
      {
        sequenceNumber: 39,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 10,
            col: 0,
          },
          to: {
            row: 8,
            col: 1,
          },
          kind: "knight",
          stateVersion: 37,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 8,
            col: 9,
          },
          to: {
            row: 9,
            col: 7,
          },
          kind: "knight",
          stateVersion: 38,
        },
      },
      {
        sequenceNumber: 41,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 8,
            col: 1,
          },
          to: {
            row: 9,
            col: 3,
          },
          kind: "knight",
          stateVersion: 39,
        },
      },
      {
        sequenceNumber: 42,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 5,
            col: 8,
          },
          to: {
            row: 3,
            col: 7,
          },
          kind: "knight",
          stateVersion: 40,
        },
      },
      {
        sequenceNumber: 43,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 10,
            col: 2,
          },
          to: {
            row: 10,
            col: 7,
          },
          kind: "slide",
          stateVersion: 41,
        },
      },
      {
        sequenceNumber: 44,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 3,
            col: 7,
          },
          to: {
            row: 5,
            col: 8,
          },
          kind: "knight",
          stateVersion: 42,
        },
      },
      {
        sequenceNumber: 45,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 10,
            col: 7,
          },
          to: {
            row: 9,
            col: 5,
          },
          kind: "knight",
          stateVersion: 43,
        },
      },
      {
        sequenceNumber: 46,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 9,
            col: 7,
          },
          to: {
            row: 8,
            col: 5,
          },
          kind: "knight",
          stateVersion: 44,
        },
      },
      {
        sequenceNumber: 47,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 4,
            col: 5,
          },
          to: {
            row: 7,
            col: 5,
          },
          kind: "slide",
          stateVersion: 45,
        },
      },
      {
        sequenceNumber: 48,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 8,
            col: 5,
          },
          to: {
            row: 7,
            col: 3,
          },
          kind: "knight",
          stateVersion: 46,
        },
      },
      {
        sequenceNumber: 49,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 4,
            col: 8,
          },
          to: {
            row: 4,
            col: 5,
          },
          kind: "slide",
          stateVersion: 47,
        },
      },
      {
        sequenceNumber: 50,
        eventType: "Move",
        userId: "p1",
        payload: {
          playerId: "p1",
          from: {
            row: 1,
            col: 5,
          },
          to: {
            row: 3,
            col: 4,
          },
          kind: "knight",
          stateVersion: 48,
        },
      },
      {
        sequenceNumber: 51,
        eventType: "Move",
        userId: "p2",
        payload: {
          playerId: "p2",
          from: {
            row: 7,
            col: 5,
          },
          to: {
            row: 5,
            col: 5,
          },
          kind: "slide",
          stateVersion: 49,
        },
      },
    ],
    notes: [
      "말달리자(run-horses)는 완전정보 게임 — 리플레이는 정규 엔진 state를 그대로 렌더(뷰어 마스킹 없음).",
      "휴리스틱 AI(얕은 미니맥스 depth=2) 자가대국. 순수 그리디는 백스톱을 못 만들어 비종료 → 미니맥스로 백스톱 슬라이드 승리를 구성.",
      "결과: 50수 만에 백(p2) 승리(오아시스 선착).",
    ],
  },
};
